export default {
  background: {
    topLeft: 0,
    topRight: 4,
    topLeftRight: 75,
    topBottom: 170,
    topBottomLeft: 99,
    topBottomLeftRight: 185,
    topBottomRight: 100,
    bottomLeft: 70,
    bottomRight: 74,
    bottomLeftRight: 89,
    left: [17, 35, 53],
    leftRight: 164,
    top: [1, 2, 3],
    right: [21, 39, 57],
    bottom: [71, 72, 73],
    ground: [18, 19, 20, 36, 37, 38, 54, 55, 56],
  },

  presentational: {
    below: 84,
  },
};

